function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "f38e1aba-af05-4903-898b-a26ded3fea7b",
  x1: 380.03851,
  y1: 760.16944,
  x2: 664.57178,
  y2: 88.29084,
  gradientTransform: "translate(-13.62976 -2.04436) rotate(-0.13928)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53514,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b2075e3e-9372-4a22-8cd3-4b0cd260a589",
  transform: "translate(-182.40264 -46.46595)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M596.92614,120.4251a28.38385,28.38385,0,0,1-27.91489,24.20959l-120.928.294a28.38386,28.38386,0,0,1-28.03226-24.0736l-64.05333.1557a13.29752,13.29752,0,0,0-13.26515,13.3298l1.39449,573.666a13.29751,13.29751,0,0,0,13.3298,13.26515l305.957-.74373a13.2975,13.2975,0,0,0,13.26515-13.3298l-1.39448-573.666A13.29752,13.29752,0,0,0,661.9547,120.267Z",
  fill: "#c4b581",
  opacity: 0.3
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a62a20e8-8665-4564-9d8e-c3ff428fbaa1",
  x1: 564.24685,
  y1: 404.52843,
  x2: 564.24685,
  y2: 230.70348,
  gradientTransform: "translate(47.68252 -77.97657) rotate(7.89081)",
  xlinkHref: "#f38e1aba-af05-4903-898b-a26ded3fea7b"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Destination");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M675.166,95.90806l-332.49756.80788a13.66379,13.66379,0,0,0-13.6336,13.69389l1.51238,621.88685a13.66389,13.66389,0,0,0,13.70005,13.62754l332.49756-.80789a13.6638,13.6638,0,0,0,13.6336-13.69394l-1.51238-621.88686A13.66387,13.66387,0,0,0,675.166,95.90806Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "url(#f38e1aba-af05-4903-898b-a26ded3fea7b)"
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 334.65221,
  y: 104.7953,
  width: 350.10707,
  height: 631.94815,
  rx: 13.63528,
  transform: "translate(-183.42395 -45.2257) rotate(-0.13928)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M596.92614,120.4251a28.38385,28.38385,0,0,1-27.91489,24.20959l-120.928.294a28.38386,28.38386,0,0,1-28.03226-24.0736l-64.05333.1557a13.29752,13.29752,0,0,0-13.26515,13.3298l1.39449,573.666a13.29751,13.29751,0,0,0,13.3298,13.26515l305.957-.74373a13.2975,13.2975,0,0,0,13.26515-13.3298l-1.39448-573.666A13.29752,13.29752,0,0,0,661.9547,120.267Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#c4b581",
  opacity: 0.3
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b2075e3e-9372-4a22-8cd3-4b0cd260a589)"
}, /*#__PURE__*/React.createElement("polyline", {
  points: "69.952 112.995 546.093 502.948 552.348 183.811 14.609 164.756 99.525 246.189 638.099 287.576 77.131 428.953 585.129 593.847 583.225 656.327 59.033 625.166 74.905 782.741 305.088 762.203 428.536 0.32",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 4
}));

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 466.82283,
  y: 128.22624,
  width: 78.01829,
  height: 4.87614,
  rx: 2,
  transform: "translate(-184.30967 -38.84735) rotate(-0.86132)",
  fill: "#dbdbdb"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 379.00375,
  cy: 82.87518,
  r: 2.92569,
  fill: "#dbdbdb"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  x: 99.19472,
  y: 130.76007,
  width: 3,
  height: 17,
  fill: "#47e6b1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 281.59736,
  y: 177.22603,
  width: 3,
  height: 17,
  transform: "translate(286.42075 -143.83729) rotate(90)",
  fill: "#47e6b1"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  x: 123.19472,
  y: 237.34224,
  width: 3,
  height: 17,
  fill: "#47e6b1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 305.59736,
  y: 283.8082,
  width: 3,
  height: 17,
  transform: "translate(417.00292 -61.25512) rotate(90)",
  fill: "#47e6b1"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  x: 583.19472,
  y: 98.76007,
  width: 3,
  height: 17,
  fill: "#47e6b1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 765.59736,
  y: 145.22603,
  width: 3,
  height: 17,
  transform: "translate(738.42075 -659.83729) rotate(90)",
  fill: "#47e6b1"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  x: 825.19472,
  y: 161.34224,
  width: 3,
  height: 17,
  fill: "#47e6b1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1007.59736,
  y: 207.8082,
  width: 3,
  height: 17,
  transform: "translate(1043.00292 -839.25512) rotate(90)",
  fill: "#47e6b1"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M194.69231,276.11365a3.67461,3.67461,0,0,1-2.04749-4.441,1.76594,1.76594,0,0,0,.07991-.40754h0a1.84257,1.84257,0,0,0-3.31045-1.22119h0a1.76633,1.76633,0,0,0-.20389.3618,3.6746,3.6746,0,0,1-4.441,2.04749,1.76646,1.76646,0,0,0-.40754-.07991h0a1.84257,1.84257,0,0,0-1.22119,3.31045h0a1.76684,1.76684,0,0,0,.3618.2039,3.67458,3.67458,0,0,1,2.04749,4.441,1.76592,1.76592,0,0,0-.0799.40754h0a1.84257,1.84257,0,0,0,3.31045,1.22119h0a1.76637,1.76637,0,0,0,.2039-.3618,3.67458,3.67458,0,0,1,4.441-2.04749,1.766,1.766,0,0,0,.40754.07991h0a1.84258,1.84258,0,0,0,1.22119-3.31045h0A1.76633,1.76633,0,0,0,194.69231,276.11365Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#4d8af0",
  opacity: 0.5
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M950.69231,467.11365a3.67461,3.67461,0,0,1-2.04749-4.441,1.76594,1.76594,0,0,0,.07991-.40754h0a1.84257,1.84257,0,0,0-3.31045-1.22119h0a1.76633,1.76633,0,0,0-.20389.3618,3.6746,3.6746,0,0,1-4.441,2.04749,1.76646,1.76646,0,0,0-.40754-.07991h0a1.84257,1.84257,0,0,0-1.22119,3.31045h0a1.76684,1.76684,0,0,0,.3618.2039,3.67458,3.67458,0,0,1,2.04749,4.441,1.76592,1.76592,0,0,0-.0799.40754h0a1.84257,1.84257,0,0,0,3.31045,1.22119h0a1.76637,1.76637,0,0,0,.2039-.3618,3.67458,3.67458,0,0,1,4.441-2.04749,1.766,1.766,0,0,0,.40754.07991h0a1.84258,1.84258,0,0,0,1.22119-3.31045h0A1.76633,1.76633,0,0,0,950.69231,467.11365Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#4d8af0",
  opacity: 0.5
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M897.69231,162.11365a3.67461,3.67461,0,0,1-2.04749-4.441,1.76594,1.76594,0,0,0,.07991-.40754h0a1.84257,1.84257,0,0,0-3.31045-1.22119h0a1.76633,1.76633,0,0,0-.20389.3618,3.6746,3.6746,0,0,1-4.441,2.04749,1.76646,1.76646,0,0,0-.40754-.07991h0a1.84257,1.84257,0,0,0-1.22119,3.31045h0a1.76684,1.76684,0,0,0,.3618.2039,3.67458,3.67458,0,0,1,2.04749,4.441,1.76592,1.76592,0,0,0-.0799.40754h0a1.84257,1.84257,0,0,0,3.31045,1.22119h0a1.76637,1.76637,0,0,0,.2039-.3618,3.67458,3.67458,0,0,1,4.441-2.04749,1.766,1.766,0,0,0,.40754.07991h0a1.84258,1.84258,0,0,0,1.22119-3.31045h0A1.76633,1.76633,0,0,0,897.69231,162.11365Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#4d8af0",
  opacity: 0.5
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M921.69231,336.11365a3.67461,3.67461,0,0,1-2.04749-4.441,1.76594,1.76594,0,0,0,.07991-.40754h0a1.84257,1.84257,0,0,0-3.31045-1.22119h0a1.76633,1.76633,0,0,0-.20389.3618,3.6746,3.6746,0,0,1-4.441,2.04749,1.76646,1.76646,0,0,0-.40754-.07991h0a1.84257,1.84257,0,0,0-1.22119,3.31045h0a1.76684,1.76684,0,0,0,.3618.2039,3.67458,3.67458,0,0,1,2.04749,4.441,1.76592,1.76592,0,0,0-.0799.40754h0a1.84257,1.84257,0,0,0,3.31045,1.22119h0a1.76637,1.76637,0,0,0,.2039-.3618,3.67458,3.67458,0,0,1,4.441-2.04749,1.766,1.766,0,0,0,.40754.07991h0a1.84258,1.84258,0,0,0,1.22119-3.31045h0A1.76633,1.76633,0,0,0,921.69231,336.11365Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#4d8af0",
  opacity: 0.5
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 72.19472,
  cy: 420.34224,
  r: 6,
  fill: "#f55f44",
  opacity: 0.5
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 584.19472,
  cy: 222.34224,
  r: 6,
  fill: "#4d8af0",
  opacity: 0.5
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 633.19472,
  cy: 374.34224,
  r: 6,
  fill: "#47e6b1",
  opacity: 0.5
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.19472,
  cy: 58.34224,
  r: 6,
  fill: "#f55f44",
  opacity: 0.5
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 670.28981,
  y: 276.00012,
  width: 22.24232,
  height: 28.59727,
  transform: "translate(-193.13968 -19.84392) rotate(-2.22071)",
  fill: "#c4b581"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M591.71009,375.65865s-30.779-14.70576-30.28646-2.00541,31.02521,21.05594,31.02521,21.05594Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#ffb9b9"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M608.59666,483.11915s-14.52107,35.54159-19.88626,61.18854-13.53608,60.94229-3.02582,85.97362,40.39191,98.59935,40.69972,106.53707-2.55946,15.99856,3.79071,15.75231,40.90677-11.12588,42.30963-15.95007-11.79-17.03205-11.79-17.03205L628.11733,617.50633,662.1068,551.0011l24.51648,99.215,4.80184,123.82843s23.56691-7.2736,26.98824-1.04655c0,0,10.55875-14.71883,11.9-21.13057s-4.98653-128.59106-4.98653-128.59106,21.63236-139.16288,4.16937-138.4857S643.63268,443.60217,608.59666,483.11915Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#2f2e41"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M629.92877,746.22052s-16.10862,35.60315-17.63461,37.25225-12.02317,17.95548-4.08545,17.64767,26.68044-8.98427,40.47584-22.23868,31.98406-36.21877,30.335-37.74476-12.9466-5.85767-12.9466-5.85767Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#2f2e41"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M694.29239,765.98365s-.97192,15.937-3.90076,22.4103-2.55947,15.99857,5.37825,15.69076,28.45267-4.28321,28.45267-4.28321,1.21817-9.58682-.43093-11.11281-8.67647-18.74271-5.68607-23.62847S694.29239,765.98365,694.29239,765.98365Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#2f2e41"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M706.03561,248.80061s16.922,26.37263,23.51842,32.47656-11.9616,19.543-11.9616,19.543l-33.2153,4.46789s.41786-30.22489-1.29281-33.33842S706.03561,248.80061,706.03561,248.80061Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#ffb9b9"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M677.16508,283.30872s6.84267,12.4541,13.19285,12.20785,39.1961-14.2394,40.599-19.0636,10.87963,34.5566,10.87963,34.5566L661.465,452.45025,641.86045,438.9011l9.49913-83.04479,7.80153-44.8206Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#c4b581"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M733.92139,409.89224c-3.206,6.70666-5.20835,13.70047-4.9307,20.86031.01231.31753.02462.635.05282.95187.76057,14.69329,6.17341,31.68646,8.11534,44.04443,1.40908,8.86485,1.00808,15.33551-4.1797,16.85636-12.57723,3.66758,1.83379,6.28861-46.826,22.48493s-57.15159,2.21623-57.27471-.95886,6.89116-27.29606,5.24206-28.822-23.07442,19.974-29.54772,17.04512-.73874-19.05053-.73874-19.05053,14.58264-33.954,14.27483-41.89176,22.08942-45.37466,22.08942-45.37466L655.432,296.87094s5.85768-12.9466,13.73384-14.842,14.411,2.621,14.411,2.621L670.397,313.77986l-13.90546,51.417,2.32629,18.989s16.17018-34.01561,26.7905-47.1469,33.26379-44.218,33.26379-44.218,5.28646-17.83738,1.2957-23.16791c-3.99136-5.34632,16.64671-6.14663,25.4463,15.77118,4.66382,11.61641,12.23581,28.93925,16.97922,45.068,4.22682,14.28851,6.22343,27.646,2.03588,35.2811C758.229,377.43719,742.1292,392.76837,733.92139,409.89224Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#575a89"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M764.62926,365.7733c-6.40029,11.66389-22.50006,26.99507-30.70787,44.11894-2.14378-7.72348-4.75909-15.71476-4.75909-15.71476s-10.03082-53.66869,19.64-67.53872a19.8576,19.8576,0,0,1,13.79106,3.85344C766.8202,344.78071,768.81681,358.13822,764.62926,365.7733Z",
  transform: "translate(-182.40264 -46.46595)",
  opacity: 0.1
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M646.8432,362.39117l-25.15446,7.33517-34.926,1.35437-3.593,30.348,57.39783,4.13394S654.904,365.25845,646.8432,362.39117Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#575a89"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M687.861,464.43075s-33.65163,5.58313-25.971,15.7098,37.49194-.51979,37.49194-.51979Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#ffb9b9"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M729.04351,431.70442c.76057,14.69329,6.17341,31.68646,8.11534,44.04443-10.72016,10.14608-20.91438,19.09523-24.75621,19.24421-7.93772.30781-20.69963-.78724-25.4007.985s-7.4583-28.32955-7.4583-28.32955,2.80572-9.64838,15.32139-14.90351C703.31283,449.18979,719.506,439.547,729.04351,431.70442Z",
  transform: "translate(-182.40264 -46.46595)",
  opacity: 0.1
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M748.43294,317.1135s26.86513-4.22164,25.41378,40.35271,2.83185,73.027-7.97315,81.39568S719.971,485.16,712.03327,485.46779s-20.69964-.78724-25.40071.985-7.45829-28.32954-7.45829-28.32954,2.80572-9.64839,15.32138-14.90352,42.00182-23.88779,41.75558-30.238-7.4583-28.32955-7.4583-28.32955S718.7621,330.98353,748.43294,317.1135Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#575a89"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 499.94294,
  cy: 206.43318,
  r: 34.95222,
  fill: "#ffb9b9"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M658.81137,202.80243a6.749,6.749,0,0,1-2.93882,1.47479,2.09717,2.09717,0,0,1-2.43029-1.68345c-.79968,1.65841-1.70192,3.42592-3.33461,4.27688s-4.15732.13741-4.39266-1.68864a7.706,7.706,0,0,1-1.77364,3.74392c-1.013.96584-2.85,1.20961-3.73439.12482.715,3.90745.27369,7.92586.49823,11.89184s1.2821,8.17049,4.27847,10.7784c4.36987,3.80334,10.94108,2.86467,16.68929,2.1441a5.06564,5.06564,0,0,1,2.61539.14308c2.15231.917,2.05467,3.9131,2.08369,6.25242a17.37277,17.37277,0,0,0,15.21221,16.4975,8.70861,8.70861,0,0,0,6.47244-1.57965c1.63206-1.38336,2.46572-3.638,4.33585-4.67723,3.04207-1.6904,6.73153.77485,8.95568,3.45157s4.4162,5.96934,7.86172,6.45932c4.55691.648,8.02766-3.996,9.73047-8.27217a48.223,48.223,0,0,0-.95837-37.46977C708.46709,193.92908,675.96382,190.64848,658.81137,202.80243Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#2f2e41"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M626.988,297.01376c-4.64068,33.48306-73.51805,103.50606-73.51805,103.50606S501.395,313.73309,506.03571,280.25A61.0544,61.0544,0,1,1,626.988,297.01376Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "url(#a62a20e8-8665-4564-9d8e-c3ff428fbaa1)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M623.01864,298.07307c-4.35288,31.40659-68.95879,97.08707-68.95879,97.08707S505.21442,313.75554,509.5673,282.349a57.26809,57.26809,0,1,1,113.45134,15.72412Z",
  transform: "translate(-182.40264 -46.46595)",
  fill: "#c4b581"
});

var _ref39 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 566.9235,
  cy: 285.66167,
  rx: 28.70512,
  ry: 28.63396,
  transform: "translate(23.73354 761.53407) rotate(-82.10919)",
  fill: "#fff"
});

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fa905f8f-095c-41f4-b37d-f1ac86376786",
    "data-name": "Layer 1",
    width: 835.19472,
    height: 784.90913,
    viewBox: "0 0 835.19472 784.90913",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map.ce18e6fe.svg";
export { ForwardRef as ReactComponent };